import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { OpenActions } from "../../actions/open.actions";
import { VendorRatingState } from "../../models/open/vendor-rating-state";

const initialState: VendorRatingState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(OpenActions.vendorRating.getSuccess, (state, action) => {
		const ratings = _.clone(_.get(state, "ratings", {}));
		_.set(ratings, action.vendorId, action.rating);
		return { ratings, loading: action.loading };
	}),
	on(OpenActions.vendorRating.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function vendorRatingReducer(
	state: VendorRatingState | undefined,
	action: Action
): VendorRatingState {
	return reducer(state, action);
}
